<!-- =========================================================================================
  File Name: DataListThumbView.vue
  Description: Data List - Thumb View
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="data-list-thumb-view" class="data-list-container">

    <add-new-data-sidebar :isSidebarActive="addNewDataSidebar" :selectedVideo="selectedRow" :buttoncaption="caption" :sidebarHeader="sbarHeader" @saveData="dataSaved" @closeSidebar="addNewDataSidebar = false" />

    <vs-table ref="videoTable" :sst="true" @search="handleSearch" @change-page="handleChangePage" v-model="selected" pagination :max-items="pageSize" search :data="videos" stripe class="vs-con-loading__container" single @selected="handleselector"> <!-- @sort="handleSort" -->

      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

        <div class="flex flex-wrap-reverse items-center">
          <!-- ADD NEW -->
          <div :buttoncaption="caption" class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-primary border border-solid border-primary" @click="showSidebar">
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
              <span class="ml-2 text-base text-primary">Add New</span>
          </div>
        </div>
      </div>

      <template slot="thead">
        <vs-th></vs-th>
        <vs-th sort-key="name">Name</vs-th>
        <vs-th sort-key="description">Description</vs-th>
        <vs-th sort-key="reviewerId">Editor</vs-th>
        <vs-th sort-key="modifiedOn">Modified On</vs-th>
        <vs-th sort-key="modifiedBy">Modified By</vs-th>
        <vs-th sort-key="videoStatusId">Status</vs-th>
      </template>

      <template slot-scope="{data}">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

            <vs-td>
              <vs-button
                radius
                color="#c72a75"
                gradient-color-secondary="#5252e8"
                type="gradient"
                icon-pack="feather"
                icon="icon-video"
                v-on:click.stop="preview(tr.id)"
              ></vs-button>
            </vs-td>

            <vs-td>
              <p class="product-name font-medium">{{ tr.name }}</p>
            </vs-td>

            <vs-td>
              <p class="product-category">{{ tr.description }}</p>
            </vs-td>

            <vs-td>
              <p class="product-category">{{ tr.editorName ? tr.editorName : "N/A" }}</p>
            </vs-td>

            <vs-td>
              <p class="product-name font-medium">{{ tr.modifiedOn.replace("T", " ").split('.')[0] }}</p>
            </vs-td>

            <vs-td>
              <p class="product-name font-medium">{{ tr.modifiedBy }}</p>
            </vs-td>

            <vs-td>
              <vs-chip v-show="tr.videoStatusId" :color="getStatusColor(tr.videoStatusId)">{{ tr.status }}</vs-chip>
            </vs-td>

          </vs-tr>
        </tbody>
      </template>
    </vs-table>
  </div>
</template>

<script>
import AddNewDataSidebar from './VideoForm.vue';

export default {
  components: {
    AddNewDataSidebar
  },
  data() {
    return {
      pageSize: 10,
      selected: [],
      videos: [],
      isMounted: false,
      addNewDataSidebar: false,
      selectedRow: {},
      caption: "",
      sbarHeader: "",
      criteria: {
        pageSize: 0,
        pageNumber: 0,
        sortKey: "",
        sortOrder: "",
        searchPhrase: "",
        showInactive: false
      }
    }
  },
  methods: {
    handleselector(tr) {
      this.addNewDataSidebar = true;
      this.selectedRow = tr;
      this.caption = "Update";
      this.sbarHeader = "Update Video";
    },
    showSidebar(){
      this.addNewDataSidebar = true;
      this.selectedRow = {};
      this.caption = "Add";
      this.sbarHeader = "Add Video";
    },
    dataSaved(){
      this.addNewDataSidebar = false;
      this.loadData();
    },
    preview(id){
      window.open('../mediapreviewer?videoId='+id, "_blank");
    },
    loadData() {
      const self = this;
      self.showLoadingOnTable();

      var onSuccess = function (response) {
        self.videos = [];

        if(self.criteria.pageNumber > 1)
          self.videos[((self.criteria.pageNumber - 1) * self.pageSize) - 1] = {};
        
        self.videos = self.videos.concat(response.data.records);
        
        if(response.data.count > (self.criteria.pageNumber * self.pageSize))
          self.videos[response.data.count - 1] = {};
      };
      var onFinally = function () {
        self.$vs.loading.close(self.$refs.videoTable.$el);
      };

      self.$ajaxPost(self, "video/GetVideosSst", self.criteria, onSuccess, onFinally);
    },
    getStatusColor(statusId) {
      var self = this;
      if(statusId == 1)
        return 'warning';
      else if(statusId == 2)
        return 'success';
      else if(statusId == 3)
        return 'success';
      else if(statusId == 4)
        return 'danger';
    },
    showLoadingOnTable(){
      var self = this;
      self.$vs.loading({
        type: "corners",
        container: self.$refs.videoTable.$el,
        scale: 1
      });
    },
    handleSearch(searchPhrase) {
      var self = this;

      if(searchPhrase.length >= 3){
        self.criteria.searchPhrase = searchPhrase;

        self.loadData();
      }
      else if (searchPhrase == ""){
        self.criteria.searchPhrase = searchPhrase;
        self.loadData();
      }
    },
    handleChangePage(pageNumber) {
      var self = this;

      if(pageNumber > 0) {
        self.criteria.pageNumber = pageNumber;

        self.loadData();
      }
    },
    handleSort(sortKey, sortOrder) {
      var self = this;

      self.criteria.sortKey = sortKey;
      self.criteria.sortOrder = sortOrder;

      self.loadData();
    }
  },
  mounted() {
    this.showLoadingOnTable();

    this.criteria.pageSize = this.pageSize;
    this.criteria.pageNumber = this.$refs.videoTable.currentPage;

    this.loadData();
    this.isMounted = true;

    if(this.$route.path == "/digi/videos")
      this.$store.dispatch("updateTheme", "dark");
  }
}
</script>

<style lang="scss">
#data-list-thumb-view {
  .vs-con-table {

    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search{
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;


      tr{
          box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
          td{
            padding: 10px;
            &:first-child{
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }
            &:last-child{
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
            &.img-container {

              span {
                display: flex;
                justify-content: center;
              }

              .product-img {
                height: 110px;
              }
            }
          }
          td.td-check{
            padding: 20px !important;
          }
      }
    }

    .vs-table--thead{
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text{
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check{
        padding: 0 15px !important;
      }
      tr{
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
